<template>
    <b-modal
            :visible="showModal === 'transitionOrderConfirm'"
            @show="initModal"
            @hidden="hideModal"
            :lazy="true"
            v-if="transition"
            >
        <div slot="modal-title">
            <h4 v-if="order" class="modal-title">Подтвердите действие для заказа №{{order.id}}</h4>
        </div>
        <loading v-if="loading" :size="3" message="Подождите..."></loading>
        <div v-else>
            <div  class="alert alert-warning">
            <h3>{{transition.name}}?</h3>
                <span v-if="transition.code == 'accept'">
                    Укажите предполагаемую сумму заказ-наряда.
                </span>
                <span v-if="transition.code == 'complete'">
                    Подтвердите сумму заказ-наряда которую заплатил клиент.
                </span>
                <span v-if="transition.code == 'calculate'">
                    Заполните данные. Они необходимы для расчетов.
                </span>
            </div>

            <form v-if="transition.code === 'accept' || transition.code === 'complete' || transition.code == 'calculate'" сlass="form-horizontal" @submit.prevent="setTransition">
                <div class="form-group row" :class="{ 'has-danger': $v.sum.$error }">
                    <label class="col-6 form-control-label" for="sum-input">Общая сумма заказ-наряда</label>
                    <div class="col-6">
                        <input type="number" rel="focusThis" @input="$v.sum.$touch()"  id="sum-input" v-model="sum" class="form-control" placeholder="Сумма по заказ-наряду">
                        <span class="small help-block text-danger" v-if="$v.sum.$error">Сумма заказ-наряда дожна быть больше 0</span>
                    </div>
                </div>
                <div v-if="transition.code === 'calculate'" class="form-group row" :class="{ 'has-danger': $v.profit.$error }">
                    <label class="col-6 form-control-label" for="profit-input">Комиссия с заказа</label>
                    <div class="col-6">
                        <input type="number" @input="$v.profit.$touch()"  id="profit-input" v-model="profit" class="form-control" placeholder="Комиссия по заказ-наряду">
                        <span class="small help-block text-danger" v-if="$v.profit.$error">Комиссия должна быть больше 0</span>
                    </div>
                </div>
                <div v-if="transition.code === 'calculate'" class="form-group row" :class="{ 'has-danger': $v.comment.$error }">
                    <label class="col-12 form-control-label" for="comment-input">Как был сделан расчет (прикрепится комментарий к заказу)</label>
                    <div class="col-12">
                        <textarea @input="$v.comment.$touch()"  id="comment-input" v-model="comment" class="form-control" placeholder="Пожалуйста распишите как можно подробнее как был произведен расчет, стоимость закупки оборудования, работы установщика и т.д." rows="4"></textarea>
                        <span class="small help-block text-danger" v-if="$v.comment.$error">Описание обязательно должно быть заполнено</span>
                    </div>
                </div>
                <button type="submit" style="display: none"></button>
            </form>
        </div>
        <div slot="modal-footer" >
            <b-btn v-if="!loading" @click.prevent="hideModal">Ничего не делать</b-btn>
            <b-btn v-if="!loading" @click.prevent="setTransition" :class="transition.class">Подтвердить</b-btn>
        </div>
    </b-modal>
</template>
<script>
  import { numeric, required, minValue, minLength } from 'vuelidate/lib/validators'
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    computed: mapState({
      showModal: state => state.orderStore.showModal,
      order: state => state.orderStore.editOrder,
      transition: state => state.orderStore.confirmTransition
    }),
    data () {
      return {
        loading: false,
        sum: 0,
        profit: 0,
        comment: ''
      }
    },
    methods: {
      setTransition () {
        switch (this.transition.code) {
          case 'accept':
            this.$v.sum.$touch()
            if (this.$v.sum.$error) {
              return
            }
            break
          case 'complete':
            this.$v.sum.$touch()
            if (this.$v.sum.$error) {
              return
            }
            break
          case 'calculate':
            this.$v.$touch()
            if (this.$v.sum.$error || this.$v.profit.$error || this.$v.comment.$error) {
              return
            }
            break
        }
        this.loading = true
        this.$store.dispatch('setOrderTransition', {
          orderId: this.order.id,
          code: this.transition.code,
          sum: this.sum,
          profit: this.profit,
          comment: this.comment
        }).then((data) => {
          this.loading = false
          this.sum = 0
          this.profit = 0
          this.comment = ''
          this.$v.$reset()
          this.$store.commit('SET_SHOW_ORDER_MODAL', null)
          this.addToast({
            text: 'Статус успешно изменен',
            type: 'success',
            dismissAfter: 3000
          })
        }).catch((error) => {
          this.loading = false
          this.addToast({
            text: 'Произошла ошибка при смене статуса заказа: ' + error,
            type: 'danger',
            dismissAfter: 3000
          })
        })
      },
      initModal () {
        this.sum = this.order.sum
        this.profit = this.order.profit
      },
      hideModal (e) {
        this.$store.dispatch('setEditOrder', null)
        this.$store.commit('SET_SHOW_ORDER_MODAL', null)
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    validations: {
      sum: {
        numeric,
        required,
        minValue: minValue(1)
      },
      profit: {
        numeric,
        required,
        minValue: minValue(1)
      },
      comment: {
        required,
        minLength: minLength(5)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalTransitionOrderConfirm.vue?614a2838